import { cn } from '@/lib/utils'

/* ---- Avatar ---------------------------------------------------------- */
export function Avatar({ src, alt = '', size = 40, ring, className }: { src: string; alt?: string; size?: number; ring?: boolean; className?: string }) {
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      className={cn('rounded-full object-cover', ring && 'border-2 border-white/40', className)}
      style={{ width: size, height: size }}
    />
  )
}

/* ---- CrafterAvatar --------------------------------------------------- */
/** Avatar that degrades to initials when no photo is available (real
 *  lifecrafter profiles don't always have one). Theme-agnostic. */
export function CrafterAvatar({ src, name, size = 44, className }: { src?: string; name: string; size?: number; className?: string }) {
  if (src) return <Avatar src={src} alt={name} size={size} className={cn('shrink-0', className)} />
  const initials =
    name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || 'LC'
  return (
    <span
      className={cn('grid shrink-0 place-items-center rounded-full bg-lc-line font-bold text-lc-ink', className)}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}
      aria-hidden="true"
    >
      {initials}
    </span>
  )
}

/* ---- AvatarStack ----------------------------------------------------- */
export function AvatarStack({
  people,
  size = 32,
  max = 4,
  className,
}: {
  people: { src: string; alt?: string }[]
  size?: number
  max?: number
  className?: string
}) {
  const shown = people.slice(0, max)
  const rest = people.length - shown.length
  return (
    <div className={cn('flex items-center', className)}>
      <div className="flex -space-x-2">
        {shown.map((p, i) => (
          <Avatar key={i} src={p.src} alt={p.alt} size={size} ring />
        ))}
      </div>
      {rest > 0 && (
        <span
          className="lc-glass-soft -ml-2 grid place-items-center rounded-full text-[12px] font-bold text-lc-ink"
          style={{ width: size, height: size }}
        >
          +{rest}
        </span>
      )}
    </div>
  )
}
